import { useListContext } from "@/components/organisms/List/List.hooks";
import { Separator } from "@/components/ui/separator";

export function ListItemDivider() {
  const { classes } = useListContext();
  return (
    <div className={classes.listItem}>
      <Separator />
    </div>
  );
}
